/* Judge.me photo-review pop-up: step between reviews without closing it, 2026-10-21.
   Judge.me's own arrows only move between the photos of ONE review (most have a single photo, so they are
   disabled). This adds a "Previous review / Next review" bar and swipe on the photo. It works by closing the
   pop-up and opening the neighbouring card in the same reviews carousel, so Judge.me still renders every review.
   Styles: assets/stryd-pages.css section 13. */
(function () {
  'use strict';
  var CARD = '.jdgm-card[data-review-id]';
  var current = null; // { root: carousel element, id: review id }

  function cardsIn(root) {
    var seen = {}, list = [];
    root.querySelectorAll(CARD).forEach(function (c) {
      if (/jdgm-clone/.test(c.className)) return; // the endless carousel repeats cards as clones
      var id = c.getAttribute('data-review-id');
      if (seen[id]) return;
      seen[id] = 1; list.push(c);
    });
    return list;
  }
  function rootOf(card) {
    return card.closest('.jdgm-cards-carousel, .jdgm-carousel-wrapper, [class*="jdgm-carousel"]:not(.jdgm-carousel-item)') || document;
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('.jdgm-modal')) return;
    var card = e.target.closest(CARD);
    if (card) current = { root: rootOf(card), id: card.getAttribute('data-review-id') };
  }, true);

  function go(step) {
    if (!current) return;
    var list = cardsIn(current.root);
    var i = -1;
    list.forEach(function (c, n) { if (c.getAttribute('data-review-id') === current.id) i = n; });
    if (i < 0 || list.length < 2) return;
    var next = list[(i + step + list.length) % list.length];
    var close = document.querySelector('.jdgm-modal .jm-indicator__close');
    if (close) close.click();
    var tries = 0;
    (function open() {
      if (document.querySelector('.jdgm-modal .jm-slide') && tries++ < 40) return setTimeout(open, 25);
      current.id = next.getAttribute('data-review-id');
      (next.querySelector('img, video, .jdgm-card__body, .jdgm-media-card__content') || next).click();
    })();
  }

  function position() {
    if (!current) return null;
    var list = cardsIn(current.root), i = -1;
    list.forEach(function (c, n) { if (c.getAttribute('data-review-id') === current.id) i = n; });
    return i < 0 || list.length < 2 ? null : { i: i, n: list.length };
  }

  function enhance(slide) {
    if (slide.getAttribute('data-stryd-rv')) return;
    var pos = position();
    if (!pos) return;
    slide.setAttribute('data-stryd-rv', '1');
    var bar = document.createElement('div');
    bar.className = 'stryd-rv-nav';
    bar.innerHTML =
      '<button type="button" data-step="-1" aria-label="Previous review"><span aria-hidden="true">&#8249;</span> Previous</button>' +
      '<span class="stryd-rv-nav__count">Review ' + (pos.i + 1) + ' of ' + pos.n + '</span>' +
      '<button type="button" data-step="1" aria-label="Next review">Next <span aria-hidden="true">&#8250;</span></button>';
    bar.addEventListener('click', function (e) {
      var b = e.target.closest('button[data-step]');
      if (b) { e.preventDefault(); e.stopPropagation(); go(+b.getAttribute('data-step')); }
    });
    // inside the review text column: pinned to the screen bottom on phones, to the column bottom on desktop (CSS)
    (slide.querySelector('.jm-content') || slide).appendChild(bar);

    // swipe on the photo when the review has a single photo (otherwise Judge.me uses swipe for its own photos)
    var media = slide.querySelector('.jm-carousel');
    var many = slide.querySelectorAll('.jm-media-grid__item').length > 1;
    if (media && !many) {
      var x0 = null, y0 = null;
      media.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
      media.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
        x0 = null;
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) go(dx < 0 ? 1 : -1);
      }, { passive: true });
    }
  }

  new MutationObserver(function () {
    var slide = document.querySelector('.jdgm-modal .jm-slide');
    if (slide) enhance(slide);
  }).observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener('keydown', function (e) {
    if (!document.querySelector('.jdgm-modal .jm-slide')) return;
    if (document.querySelectorAll('.jdgm-modal .jm-media-grid__item').length > 1) return;
    if (e.key === 'ArrowRight') go(1);
    if (e.key === 'ArrowLeft') go(-1);
  });
})();
